/* eslint-disable check-file/no-index */
import { combineReducers, createSelector } from '@reduxjs/toolkit';

import { bboxesReducer } from './bboxes/bboxes.slice';
import { cameraReducer } from './camera/camera.slice';
import { exportsReducer } from './exports/export.slice';
import { selectIsLocalProject } from './project/project.selectors';
import { projectReducer } from './project/project.slice';
import {
  selectHasPendingFiles,
  selectSyncLoading,
} from './sync/sync.selectors';
import { syncReducer } from './sync/sync.slice';
import { selectProjectIsLoading } from './ui/editor-ui.selectors';
import { uiReducer } from './ui/editor-ui.slice';

export const editorReducers = combineReducers({
  ui: uiReducer,
  camera: cameraReducer,
  bboxes: bboxesReducer,
  project: projectReducer,
  sync: syncReducer,
  export: exportsReducer,
});

/**
 * Use this to determine whenever exiting from the editor
 * should be prevented with an alert of some sort.
 * These are all the conditions checked.
 */
export const selectEditorRouteLocked = createSelector(
  [
    selectSyncLoading,
    selectHasPendingFiles,
    selectProjectIsLoading,
    selectIsLocalProject,
  ],
  (syncing, hasPendingFiles, projectLoading, isLocalProject) =>
    syncing || hasPendingFiles || Boolean(projectLoading) || isLocalProject,
);
